export const styles = /* css */ `
:host {
  --ca-accent: #5e6ad2;
  --ca-accent-fg: #fff;
  --ca-bg: #fff;
  --ca-fg: #1b1b1f;
  --ca-muted: #6b6f76;
  --ca-border: rgba(15, 15, 20, 0.09);
  --ca-bubble: #f1f1f3;
  --ca-surface: #fafafa;
  --ca-radius: 16px;
  --ca-shadow: 0 16px 48px rgba(15, 15, 20, 0.16), 0 2px 8px rgba(15, 15, 20, 0.06);
  --ca-online: #2fb36d;
  font-family: var(--ca-font, ui-sans-serif, system-ui, -apple-system, "Segoe UI", Inter, Roboto, sans-serif);
  font-size: 15px;
  line-height: 1.55;
  color: var(--ca-fg);
  -webkit-font-smoothing: antialiased;
}
* { box-sizing: border-box; }
[hidden] { display: none !important; }
button { font: inherit; color: inherit; cursor: pointer; }

/* ---------- launcher ---------- */
.launcher {
  position: fixed; right: 20px; bottom: 20px; z-index: 2147483000;
  width: 52px; height: 52px; border-radius: 50%; border: 0;
  background: var(--ca-accent); color: var(--ca-accent-fg);
  display: grid; place-items: center;
  box-shadow: 0 6px 20px rgba(15, 15, 20, 0.22);
  transition: transform .18s ease, box-shadow .18s ease;
}
.launcher:hover { transform: translateY(-1px) scale(1.04); box-shadow: 0 10px 28px rgba(15, 15, 20, 0.26); }
.launcher:focus-visible { outline: 3px solid color-mix(in srgb, var(--ca-accent) 40%, transparent); outline-offset: 3px; }
.launcher svg { width: 24px; height: 24px; transition: transform .2s ease, opacity .2s ease; }
.launcher .badge {
  position: absolute; top: -2px; right: -2px; min-width: 18px; height: 18px; padding: 0 5px;
  border-radius: 9px; background: #e5484d; color: #fff; font-size: 11px; font-weight: 600;
  display: grid; place-items: center; border: 2px solid var(--ca-bg);
}
.panel {
  position: fixed; right: 20px; bottom: 84px; z-index: 2147483000;
  width: 392px; height: min(640px, calc(100vh - 112px));
  display: flex; flex-direction: column; overflow: hidden;
  background: var(--ca-bg); border: 1px solid var(--ca-border);
  border-radius: var(--ca-radius); box-shadow: var(--ca-shadow);
  transform-origin: bottom right;
  animation: ca-pop .18s cubic-bezier(.2, .9, .3, 1.2);
}
@keyframes ca-pop { from { opacity: 0; transform: translateY(8px) scale(.98); } }
.panel header {
  display: flex; align-items: center; gap: 10px; padding: 14px 14px 12px 16px;
  border-bottom: 1px solid var(--ca-border);
}
.panel header .who { flex: 1; min-width: 0; }
.panel header .title { font-weight: 600; font-size: 14.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.panel header .status { font-size: 12.5px; color: var(--ca-muted); display: flex; align-items: center; gap: 6px; }
.dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ca-muted); opacity: .6; }
.dot.on { background: var(--ca-online); opacity: 1; box-shadow: 0 0 0 3px color-mix(in srgb, var(--ca-online) 20%, transparent); }
.icon-btn { border: 0; background: none; width: 30px; height: 30px; border-radius: 8px; display: grid; place-items: center; color: var(--ca-muted); }
.icon-btn:hover { background: var(--ca-bubble); color: var(--ca-fg); }
@media (max-width: 480px) {
  .panel { inset: 0; width: auto; height: auto; border-radius: 0; border: 0; }
  .launcher.open { display: none; }
}

/* ---------- shared conversation ---------- */
.log { flex: 1; overflow-y: auto; padding: 16px; display: flex; flex-direction: column; gap: 14px; overscroll-behavior: contain; }
.msg { display: flex; gap: 10px; align-items: flex-start; max-width: 100%; }
.msg.visitor { justify-content: flex-end; }
.bubble { padding: 9px 13px; border-radius: 14px; max-width: 85%; overflow-wrap: anywhere; }
.msg.visitor .bubble { background: var(--ca-accent); color: var(--ca-accent-fg); border-bottom-right-radius: 5px; white-space: pre-wrap; }
.msg.assistant .bubble, .msg.owner .bubble { background: var(--ca-bubble); border-bottom-left-radius: 5px; }
.msg .body { display: flex; flex-direction: column; gap: 3px; min-width: 0; max-width: 85%; }
.msg .body .bubble { max-width: 100%; }
.msg .name { font-size: 12px; color: var(--ca-muted); font-weight: 500; }
.avatar {
  flex: none; width: 28px; height: 28px; border-radius: 50%; display: grid; place-items: center;
  font-size: 12.5px; font-weight: 600; background: var(--ca-bubble); color: var(--ca-fg);
}
.avatar.ai { background: var(--ca-accent); color: var(--ca-accent-fg); }
.avatar.ai svg { width: 15px; height: 15px; }
.avatar.owner { background: color-mix(in srgb, var(--ca-online) 18%, var(--ca-bg)); color: color-mix(in srgb, var(--ca-online) 70%, var(--ca-fg)); }
.msg.system { justify-content: center; font-size: 12.5px; color: var(--ca-muted); }
.md p { margin: 0; }
.md p + p, .md p + ul, .md ul + p, .md p + ol, .md ol + p { margin-top: .6em; }
.md ul, .md ol { margin: 0; padding-left: 1.25em; }
.md a { color: inherit; text-decoration: underline; text-underline-offset: 2px; text-decoration-color: color-mix(in srgb, currentColor 40%, transparent); }
.md a:hover { text-decoration-color: currentColor; }
.md code { font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: .88em; padding: .1em .35em; border-radius: 5px; background: color-mix(in srgb, var(--ca-fg) 8%, transparent); }
.typing { display: inline-flex; gap: 4px; align-items: center; padding: 13px 14px; }
.typing span { width: 6px; height: 6px; border-radius: 50%; background: var(--ca-muted); animation: ca-blink 1.2s infinite ease-in-out; }
.typing span:nth-child(2) { animation-delay: .15s; }
.typing span:nth-child(3) { animation-delay: .3s; }
@keyframes ca-blink { 0%, 80%, 100% { opacity: .25; transform: translateY(0); } 40% { opacity: 1; transform: translateY(-2px); } }
.error { margin: 0 16px 8px; padding: 8px 12px; border-radius: 10px; font-size: 13px; background: color-mix(in srgb, #e5484d 12%, var(--ca-bg)); color: color-mix(in srgb, #e5484d 75%, var(--ca-fg)); }

.challenge { display: flex; justify-content: center; position: relative; }
.composer { padding: 10px 12px 12px; }
.field {
  display: flex; align-items: flex-end; gap: 8px; padding: 6px 6px 6px 14px;
  border: 1px solid var(--ca-border); border-radius: 22px; background: var(--ca-bg);
  transition: border-color .15s ease, box-shadow .15s ease;
}
.field:focus-within { border-color: color-mix(in srgb, var(--ca-accent) 55%, var(--ca-border)); box-shadow: 0 0 0 3px color-mix(in srgb, var(--ca-accent) 14%, transparent); }
textarea {
  flex: 1; border: 0; outline: 0; resize: none; background: transparent; color: inherit;
  font: inherit; line-height: 1.45; padding: 7px 0; max-height: 160px; min-height: 22px;
}
textarea::placeholder { color: var(--ca-muted); }
.send {
  flex: none; width: 34px; height: 34px; border-radius: 50%; border: 0;
  background: var(--ca-fg); color: var(--ca-bg); display: grid; place-items: center;
  transition: opacity .15s ease, transform .1s ease;
}
.send:disabled { opacity: .25; cursor: default; }
.send:not(:disabled):active { transform: scale(.94); }
.send svg { width: 17px; height: 17px; }
.foot { text-align: center; font-size: 11.5px; color: var(--ca-muted); padding: 0 12px 10px; }
.link-btn { border: 0; background: none; padding: 0; margin-left: 10px; font-size: inherit; color: inherit; text-decoration: underline; text-underline-offset: 2px; }
.link-btn:hover { color: var(--ca-fg); }

/* ---------- inline (ChatGPT / Claude style) ---------- */
.inline { display: flex; flex-direction: column; height: 100%; min-height: var(--ca-min-height, 520px); background: var(--ca-bg); }
.inline .log { padding: 24px 16px; gap: 22px; }
.inline .log > *, .inline .composer > *, .inline .foot { width: 100%; max-width: 760px; margin-left: auto; margin-right: auto; }
.inline .msg.assistant .bubble, .inline .msg.owner .bubble { background: none; padding: 3px 0 0; border-radius: 0; }
.inline .msg.visitor .bubble { background: var(--ca-bubble); color: var(--ca-fg); border-radius: 20px; padding: 10px 16px; max-width: 75%; }
.inline .avatar { width: 30px; height: 30px; }
.inline .composer { position: sticky; bottom: 0; padding: 8px 16px 10px; background: linear-gradient(to bottom, transparent, var(--ca-bg) 30%); }
.inline .field { border-radius: 26px; padding: 8px 8px 8px 18px; background: var(--ca-surface); box-shadow: 0 1px 2px rgba(15, 15, 20, 0.04); }
.inline .send { width: 36px; height: 36px; }
.hero { flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 18px; padding: 24px 0; }
.hero h2 { margin: 0; font-size: clamp(22px, 3.2vw, 30px); font-weight: 600; letter-spacing: -0.02em; line-height: 1.25; }
.hero p { margin: 0; color: var(--ca-muted); max-width: 520px; }
/* Suggestions: a quiet list of rows, like ChatGPT's. */
.chips { display: flex; flex-direction: column; gap: 2px; width: 100%; max-width: 560px; }
.chip {
  display: flex; align-items: center; gap: 12px; width: 100%; text-align: left; line-height: 1.35;
  border: 0; background: transparent; border-radius: 14px; padding: 10px 14px;
  font-size: 14.5px; color: var(--ca-muted); transition: background .15s ease, color .15s ease;
}
.chip svg { width: 16px; height: 16px; flex: none; }
.chip:hover, .chip:focus-visible { background: var(--ca-bubble); color: var(--ca-fg); outline: 0; }
.hero .chips { align-self: center; max-width: 440px; }
.inline .status-line { display: flex; align-items: center; justify-content: center; gap: 6px; font-size: 12.5px; color: var(--ca-muted); }

/* ---------- compact: a message box on the page that morphs into a dialog ---------- */
.inline.compact { height: auto; min-height: 0; background: none; }
.trigger .field {
  padding: 10px 10px 10px 20px; border-radius: 28px; background: var(--ca-bg); cursor: text;
  box-shadow: 0 8px 28px rgba(15, 15, 20, 0.12), 0 1px 2px rgba(15, 15, 20, 0.06);
}
.trigger input {
  flex: 1; min-width: 0; border: 0; outline: 0; background: transparent; color: inherit; cursor: text;
  font: inherit; line-height: 1.45; padding: 7px 0; text-overflow: ellipsis;
}
.trigger input::placeholder { color: var(--ca-muted); }
.card textarea:placeholder-shown { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.trigger .send { opacity: .25; width: 36px; height: 36px; }
.trigger.unread .field { border-color: color-mix(in srgb, var(--ca-accent) 60%, var(--ca-border)); }
.trigger.unread input::placeholder { color: var(--ca-fg); }
.trigger.unread .send { opacity: 1; background: var(--ca-accent); color: var(--ca-accent-fg); }
.chips-slot .chips { margin-top: 10px; max-width: none; }
.chips-slot .chip { padding-left: 20px; }

dialog.sheet {
  position: fixed; inset: 0; width: 100%; height: 100%; max-width: none; max-height: none;
  margin: 0; padding: 0; border: 0; background: transparent; color: inherit; overflow: hidden;
}
dialog.sheet::backdrop { background: transparent; }
.scrim { position: absolute; inset: 0; background: rgba(6, 6, 10, 0.42); -webkit-backdrop-filter: blur(8px); backdrop-filter: blur(8px); }
.card { position: absolute; display: flex; flex-direction: column; overflow: hidden; border-radius: 24px; }
.card-bg { position: absolute; inset: 0; border-radius: inherit; background: var(--ca-bg); border: 1px solid var(--ca-border); box-shadow: var(--ca-shadow); pointer-events: none; }
.card header {
  position: absolute; top: 0; left: 0; right: 0; z-index: 1;
  display: flex; align-items: center; gap: 10px; padding: 14px 14px 18px 18px;
  background: linear-gradient(to bottom, var(--ca-bg) 60%, transparent);
}
.card header .who { flex: 1; min-width: 0; }
.card header .title { font-weight: 600; font-size: 14.5px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.card header .status { font-size: 12.5px; color: var(--ca-muted); display: flex; align-items: center; gap: 6px; }
/* Spacers instead of padding, so the log can shrink to nothing while the card is still the size of the box. */
.card .log { position: relative; flex: 1 1 0; min-height: 0; padding: 0 20px; gap: 20px; }
.card .log::before { content: ""; flex: none; height: 52px; }
.card .log::after { content: ""; flex: none; height: 0; }
.card .log > * { width: 100%; max-width: 680px; margin-left: auto; margin-right: auto; }
.card .msg.assistant .bubble, .card .msg.owner .bubble { background: none; padding: 3px 0 0; border-radius: 0; }
.card .msg.visitor .bubble { background: var(--ca-bubble); color: var(--ca-fg); border-radius: 20px; padding: 10px 16px; max-width: 80%; }
.card .avatar { width: 30px; height: 30px; }
.card .greeting .chips { padding-left: 26px; }
.card .composer { position: relative; flex: none; padding: 8px 14px 14px; }
.card .field { max-width: 680px; margin: 0 auto; border-radius: 26px; padding: 8px 8px 8px 18px; background: var(--ca-surface); }
.card .send { width: 36px; height: 36px; }
.card .error { position: relative; }
@media (max-width: 640px) {
  .card-bg { border: 0; box-shadow: none; }
  .card header { padding-top: max(14px, env(safe-area-inset-top)); }
  .card .log { padding-left: 16px; padding-right: 16px; }
  .card .log::before { height: calc(52px + env(safe-area-inset-top)); }
  .card .composer { padding: 8px 10px max(10px, env(safe-area-inset-bottom)); }
}

/* Phones zoom into inputs smaller than 16px. */
@media (pointer: coarse) { textarea, input { font-size: 16px; } }
`;

// Dark palette, applied when theme="dark" or the system prefers dark (unless theme="light").
export const darkVars = /* css */ `
  --ca-bg: #1c1c1f;
  --ca-fg: #ececef;
  --ca-muted: #9b9ba4;
  --ca-border: rgba(255, 255, 255, 0.09);
  --ca-bubble: #2a2a2f;
  --ca-surface: #232327;
  --ca-shadow: 0 16px 48px rgba(0, 0, 0, 0.5), 0 2px 8px rgba(0, 0, 0, 0.3);
`;

export const themeCss = /* css */ `
:host([theme="dark"]) { ${darkVars} }
@media (prefers-color-scheme: dark) { :host(:not([theme="light"])) { ${darkVars} } }
`;
